import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import { heroSchema, SECTION_DEFAULTS } from "../schemas";

const HeroEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="hero"
    schema={heroSchema}
    defaults={SECTION_DEFAULTS.hero}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField
          form={form}
          path="eyebrow"
          label="Eyebrow"
          hint="Optional small uppercase text above the headline."
        />
        <TextField
          form={form}
          path="headline"
          label="Headline"
          hint="Wrap a word in *asterisks* to make it the gradient italic accent (e.g. Think *clearly*)."
          required
        />
        <TextareaField
          form={form}
          path="subtext"
          label="Subtext"
          required
          rows={3}
        />
      </>
    )}
  </EditorShell>
);

export default HeroEditor;
